
import * as React from "react";
import {NavLink} from "react-router-dom";
import {CreditService} from "../../services/CreditService";
import {getContainer} from "../../ioc/IOCSetup";
import {DeleteButtonModal} from "../../util/DeleteButtonModal";
import {Credit, CreditStatus} from "../../http/protocol";

interface Props { credit? : Credit, onCreditUpdated : ()=> void}
export class CreditActions extends React.Component<Props, {}> {

    creditService : CreditService;
    constructor(props : Props) {
        super(props);
        this.creditService = getContainer().getCreditService();
    }
    render() {
        if(!this.props.credit) {
            return <span></span>
        }
       return (
           <div className="card-box">
               <h5>Credit Actions</h5>


                   { this.props.credit.status === CreditStatus.PENDING &&
                        <DeleteButtonModal className="btn btn-danger" onDelete={()=>{
                            if(!this.props.credit || !this.props.credit.id) return;
                            return this.creditService.cancelCredit(this.props.credit.id).then(()=>{
                                this.props.onCreditUpdated();
                            })
                        }} label="Cancel"/>
                   }
                    &nbsp;
                   { this.props.credit.status === CreditStatus.PENDING &&
                        <DeleteButtonModal className="btn btn-danger" onDelete={()=>{
                            if(!this.props.credit) return;
                            return this.creditService.collectCredit(this.props.credit).then(()=>{
                                this.props.onCreditUpdated();
                            })
                        }} label="Collect"/>
                   }
                   &nbsp;
                   <NavLink className={"btn btn-primary"} to={"/credit/review/"+this.props.credit.reference}>Review</NavLink>
           </div>
       )
    }
}